// Copyright 2016 Sorama B.V.

import { BindingEngine, bindingMode, customAttribute, DOM, inject } from "aurelia-framework";
import { EventInterceptorOverride, IEventRegistrationListener } from "overrides/EventInterceptorOverride";

@customAttribute("event-observer", bindingMode.twoWay)
@inject(DOM.Element, BindingEngine, EventInterceptorOverride)
export class EventObserver implements IEventRegistrationListener {
    //#region Injected Services
    private element: HTMLElement;
    private bindingEngine: BindingEngine;
    private eventInterceptorOverride: EventInterceptorOverride;
    //#endregion

    //#region Fields
    private modifiedElements: { element: HTMLElement; originalPointerEventsValue: string }[] = [];
    //#endregion

    constructor(
        element: HTMLInputElement,
        bindingEngine: BindingEngine,
        eventInterceptorOverride: EventInterceptorOverride
    ) {
        this.element = element;
        this.bindingEngine = bindingEngine;
        this.eventInterceptorOverride = eventInterceptorOverride;
    }

    private bind(): void {
        this.eventInterceptorOverride.register(this);
    }

    private unbind(): void {
        this.eventInterceptorOverride.unregister(this);
    }

    public eventListenerAdded(target: EventTarget, eventName: string, eventHandler: unknown): void {
        const element = <HTMLElement>target;

        if (!element.style) return;

        // Start observing this event if the element is a child element
        if (this.element !== element && this.element.contains(element)) {
            // Subscribe to the same event
            this.element.addEventListener(eventName, this.eventHandler);
        }
    }

    public eventListenerRemoved(target: EventTarget, eventName: string, eventHandler: unknown): void {
        const element = <HTMLElement>target;

        if (!element.style) return;

        if (this.element !== element && this.element.contains(element)) {
            this.element.removeEventListener(eventName, this.eventHandler);
        }
    }

    public eventHandler = (event: Event): void => {};
}
